import { render } from "./AddPanelAccess.vue?vue&type=template&id=70a4a6a1&scoped=true"
import script from "./AddPanelAccess.vue?vue&type=script&lang=js"
export * from "./AddPanelAccess.vue?vue&type=script&lang=js"

import "./AddPanelAccess.vue?vue&type=style&index=0&id=70a4a6a1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a4a6a1"],['__file',"src/assets/js/components/panels/forms/AddPanelAccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70a4a6a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70a4a6a1', __exports__)) {
    api.reload('70a4a6a1', __exports__)
  }
  
  module.hot.accept("./AddPanelAccess.vue?vue&type=template&id=70a4a6a1&scoped=true", () => {
    api.rerender('70a4a6a1', render)
  })

}


export default __exports__